// import 'ag-grid-community/dist/styles/ag-grid.css';
// import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from "ag-grid-react";
import { useCallback, useMemo, useRef, useState, useEffect } from "react";
import './index.css';
import CustomHeader from "./customHeader";
import HtmlRenderer from './htmlRenderer';
import IconRenderer from './iconRenderer';

import PaginationBottom from "./paginationBottom";
import PaginationTop from "./paginationTop";
import StarsRenderer from "./starsRenderer";
import multiRenderer from './multiRenderer';
import Mentor from '../../assets/svg/Mentor';
let columnApi;

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
    const options = props.options || {};
    const pageData = props.pageData || {};
    const gridRef = useRef();
    const intervalRef = useRef(null);
    const [hideColumnToggle, setHideColumnToggle] = useState(false);
    const [headerData, setHeaderData] = useState(JSON.parse(JSON.stringify(props?.headers)));
    const [checkedAll, setCheckedAll] = useState(true);
    const [showResize, setShowResize] = useState(false)
    // const containerStyle = useMemo(() => ({ width: '100%', height: '400px', overflow: 'scroll' }), []);
    // const gridStyle = useMemo(() => ({ height: '100%', width: '100%', overflow: 'scroll' }), []);
    const containerStyle = useMemo(() => ({ width: '100%', height: options.height ? '' : '400px' }), []);
    const gridStyle = useMemo(() => ({ height: '100%', width: '100%', overflow: 'scroll' }), []);
    const components = useMemo(() => {
        return {
            agColumnHeader: CustomHeader,
        };
    }, []);
    useEffect(() => {
        const isColumnRefreshed = localStorage.getItem("columnRefresh");
        if (props?.pageName && isColumnRefreshed) {
            const col = JSON.parse(localStorage.getItem(props?.pageName))
            // console.log(col, 'col---------');
            if(col?.length){
                const localFieldsList = col?.map(data => data?.field);
                if(props?.pageName !== "openShift" && localFieldsList?.indexOf("matching") > -1){
                    setHeaderData(headerData)
                    localStorage.setItem(props?.pageName, JSON.stringify((props?.headers)));
                } else {
                    setHeaderData(col)
                }
            }

        }
        window.addEventListener("resize", handler, false);
        return () => {
            window.removeEventListener("resize", handler);
        }
    }, [])

    const handler = e => {
        if (window.innerWidth && window.innerWidth > 3000) {
            sizeToFit()
        } else {
            const allColumnIds = [];
            gridRef.current.columnApi.getColumns().forEach((column) => {
                allColumnIds.push(column.getId());
            });
            gridRef.current.columnApi.autoSizeColumns(allColumnIds, false);
        }
    };
    const columnDefs = props?.headers?.map((header) => {
        const columnDef = {
            field: header.name
        }
        if (header.type === 'icon') {
            columnDef.cellRenderer = IconRenderer
        }
        if (header.type === 'ratings') {
            columnDef.cellRenderer = StarsRenderer
        }
        if (header.type === 'text') {
            columnDef.cellRenderer = HtmlRenderer
            if(header.field === "isMentor"){
                columnDef.headerComponentFramework = Mentor
            }
        }
        if (header.type === 'multi') {
            columnDef.cellRenderer = multiRenderer
        }
        columnDef.filter = header.filter
        columnDef.sortable = header.sort;
        columnDef.comparator = header.comparator;
        columnDef.minWidth = header.minWidth || 100;

        if (header?.headerTooltip) {
            columnDef.headerTooltip = header.headerTooltip
        }
        if (header?.wrapHeaderText) {
            columnDef.wrapHeaderText = header.wrapHeaderText
        }
        if (header?.autoHeaderHeight) {
            columnDef.autoHeaderHeight = header.autoHeaderHeight
        }
        if (header?.autoHieght) {
            columnDef.autoHieght = header.autoHieght
        }
        if (header?.wrapText) {
            columnDef.wrapText = header.wrapText
        }
        if (header?.maxWidth) {
            columnDef.maxWidth = header.maxWidth
        }
        if (header?.width) {
            columnDef.width = header.width
        }
        if (header?.suppressSizeToFit) {
            columnDef.suppressSizeToFit = header.suppressSizeToFit
        }
        return columnDef;
    });
    const gridReady = (params) => {
        const api = params.api;
        columnApi = params.columnApi;
        api.hideOverlay();
        api.showNoRowsOverlay();
        const hideCol = headerData.filter(item => item.hide === true).map(item => item.name);
        if (hideCol.length > 0) {
            columnApi.setColumnsVisible(hideCol, false);
        }
        api.sizeColumnsToFit();
        // autoSizeAll()
        window.onresize = () => {
            api.sizeColumnsToFit();
        }
        api.setDomLayout(options.layout || "normal");
    }

    const rowData = props?.rows?.map(row => {
        const columns = row.columns;
        const keys = Object.keys(columns);
        const rowData = {};
        keys.forEach(key => {
            rowData[key] = columns[key]
        });
        return rowData;
    });
    const defaultColDef = {
        filter: options.filter || false,
        headerComponentParams: props.headerComponentParams,
        resizable: true,
        wrapHeaderText: true,
        autoHeaderHeight: true,
    }
    // wrapHeaderText: true,
    // autoHeaderHeight: true,
    // wrapText: true,
    // autoHeight: true,
    // resizable: true,

    const sizeToFit = useCallback(() => {
        gridRef.current.api.sizeColumnsToFit();
    }, []);

    const autoSizeAll = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRef.current.columnApi.getColumns().forEach((column) => {
            allColumnIds.push(column.getId());
        });
        gridRef.current.columnApi.autoSizeColumns(allColumnIds, skipHeader);
    }, []);

    const hideAndShow = (e, name) => {
        const newData = headerData.map((item) => {
            if (item.name === name) {
                item.hide = !e.target.checked;
            }
            return item;
        });
        if (props?.pageName) {
            localStorage.setItem(props?.pageName, JSON.stringify(newData))
        }

        setHeaderData(newData);
        columnApi.setColumnVisible(name, e.target.checked)
    }
    const hideAll = (e) => {

        setCheckedAll((pre) => !pre);
        const newData = headerData.map((item) => {
            item.hide = !e.target.checked;
            return item;
        });
        setHeaderData(newData);
        if (props?.pageName) {
            localStorage.setItem(props?.pageName, JSON.stringify(newData))
        }
        columnApi.setColumnsVisible(headerData.map(item => item.name), e.target.checked);
    }

    const toggleColumnHandler = () => {
        setHideColumnToggle(!hideColumnToggle);
        const isColumnRefreshed = localStorage.getItem("columnRefresh");
        if(!isColumnRefreshed){
        localStorage.setItem(props?.pageName, JSON.stringify((props?.headers)));
        localStorage.setItem("columnRefresh", true);
        setHeaderData(headerData)
        }
    }
    // const rowClassRules = useMemo(() => {
    //     return {
    //         // row style function
    //         'rowhighlight': (params) => {
    //             var shiftType = params.data?.shiftType;
    //             return shiftType === 3;
    //         },
    //     };
    // }, []);
    const handleHorizantalScroll = ( speed, distance, step) => {
        const element = document.querySelector('.ag-center-cols-viewport')
        // let scrollAmount = 0;
        intervalRef.current = setInterval(() => {
          element.scrollLeft += step;
        //   scrollAmount += Math.abs(step);
        //   console.log({scrollAmount,distance});
        // //   if (scrollAmount >= distance) {
        // //     clearInterval(intervalRef.current);
        // //   }
        }, speed);
      };
      const startScrolling = (speed, distance, step) => {
        handleHorizantalScroll(speed, distance, step)
      };
      const stopScrolling  = () => {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    return (
        <>
            <div className='d-flex justify-content-between'>
                <span className='d-flex'>
                    {options.pagination &&
                        <PaginationTop pageData={pageData} updatePageSize={props.updatePageSize} />
                    }
                    <div>{options?.refreshFlag &&
                        <button className={`btn btn-primary btn-sm ms-2 mt-2 ${!options.pagination ? 'mb-4' : ""}`} onClick={() => props?.refresh()}><i class="fe fe-refresh-cw" style={{ color: 'white' }}></i>  Refresh</button>
                    }</div>
                    <div>{
                        options?.resizable && <button className='btn btn-primary btn-sm ms-2 mt-2' onClick={() => { setShowResize(!showResize) }}>
                            <i class="fe fe-maximize fa-lg" style={{ color: 'white' }}></i>
                        </button>
                    }
                    </div>
                    <div>
                        {showResize &&
                            <>
                                <button className='btn btn-primary btn-sm ms-2 mt-2' onClick={sizeToFit}>Size to Fit</button>
                                <button className='btn btn-primary btn-sm ms-2 mt-2' onClick={() => autoSizeAll(false)}>Auto-Size All</button>
                                {/* <button className='btn-sm me-2' onClick={() => autoSizeAll(true)}>
                                    Auto-Size All (Skip Header)
                                </button> */}
                            </>
                        }</div>
                </span>
                <span className="me-2">
                    <span className="button-bar mb-2 rounded-circle">
                        {/* {
                            options?.loader ? options?.gridloader ? <span className='me-2 fw-bold'>Loading...</span> : rowData && rowData.length > 0 ? '' : <span className='me-2 fw-bold'></span> : ''
                        } */}
                    </span>

                    {options?.showToggle &&
                        <>
                            <button className="btn btn-primary btn-sm mt-2" type="button"
                                onClick={toggleColumnHandler}>Toggle Columns</button>
                            {hideColumnToggle &&
                                <>
                                    <div className='toggleColumn mt-1'>
                                        <div>
                                            <input type="checkbox" onChange={(e) => { hideAll(e) }} checked={checkedAll} />{' '}
                                            Toggle
                                            All
                                        </div>
                                        {headerData?.map((header, index) => (
                                            <div key={index}>
                                                <label>
                                                    <input type="checkbox" onChange={(e) => { hideAndShow(e, header.name) }} checked={!header.hide} />{' '}
                                                    {header.name === "Unclaim" ? 'UnClaim':header.name}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            }
                        </>
                    }
                        <button
                            onMouseDown={() => startScrolling(10, 100, -25)}
                            onMouseLeave={stopScrolling}
                            onMouseUp={stopScrolling}
                            className="btn btn-primary btn-sm mt-2 ms-2"
                            type="button"
                        >
                            <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        </button>
                        <button
                          onMouseDown={() => startScrolling(10, 100, 25)}
                          onMouseLeave={stopScrolling}
                          onMouseUp={stopScrolling}
                            // onClick={() => handleHorizantalScroll()}
                            className="btn btn-primary btn-sm mt-2 ms-2"
                            type="button"
                        >
                            <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </button>                  
                </span>
            </div>

            <div style={containerStyle}>
                <div style={gridStyle} className="ag-theme-alpine">
                    <AgGridReact
                        rowData={rowData}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        animateRows={options.animate || true}
                        onGridReady={gridReady}
                        onGridColumnsChanged={gridReady}
                        pagination={options.pagination}
                        suppressPaginationPanel={true}
                        alwaysShowHorizontalScroll={true}
                        scrollbarWidth={8}
                        components={components}
                        tooltipShowDelay={0}
                        ref={gridRef}
                        overlayNoRowsTemplate={"."}
                    // rowClassRules={rowClassRules}
                    />
                </div>
            </div>
            {
                options.pagination &&
                <PaginationBottom {...props} />
            }
        </>

    )
}
